'use client'

// Headless UI
import {
  Tab as HeadlessTab,
  TabGroup,
  TabList,
  TabPanels,
  TabPanel,
} from '@headlessui/react'

/** Tab button styles (aligned with chart section tabs in product apps). */
const chartTabStyles = {
  base: 'px-4 py-2.5 text-sm font-medium leading-5 rounded-lg cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-500/30 transition-all',
  selected: 'bg-blue-600 text-white shadow-md',
  unselected:
    'text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 hover:text-blue-600 dark:hover:text-blue-400',
} as const

// Export each Tab component separately for use in MDX
export { TabGroup, TabList, TabPanels, TabPanel }

// Wrapper for Tab button with theme styling
// Use variant="teal" for the hero-style compact toggle
export function Tab({
  children,
  className,
  variant,
  onClick,
}: {
  children: React.ReactNode
  className?: string | ((props: { selected: boolean }) => string)
  variant?: 'default' | 'teal'
  onClick?: () => void
}) {
  const resolvedClassName =
    className ??
    (variant === 'teal'
      ? ({ selected }: { selected: boolean }) =>
          `rounded-md px-3 py-1 text-xs font-medium transition-all cursor-pointer ${
            selected
              ? 'bg-teal-600 text-white shadow'
              : 'text-slate-600 hover:text-slate-900 dark:text-slate-400 dark:hover:text-slate-200'
          }`
      : ({ selected }: { selected: boolean }) =>
          `${chartTabStyles.base} ${selected ? chartTabStyles.selected : chartTabStyles.unselected}`)

  return (
    <HeadlessTab onClick={onClick} className={resolvedClassName}>
      {children}
    </HeadlessTab>
  )
}
